import React from 'react'
import LoginFormComponent from './LoginForm'
import Authentication from '../modules/Authentication'
import UserApi from '../api/User'
import { withRouter } from 'react-router-dom'
import Members from '../api/Members'
import { message } from 'antd'
import GeoNames from '../api/external/GeoNames'
import { omit } from 'lodash'
import publicIp from 'public-ip'

class LoginFormCont extends React.Component {
  constructor(props) {
    super(props)
    this.api = new UserApi()
    this.membersApi = new Members()
    this.auth = new Authentication()
    this.state = {
      error: { message: '', type: '', key: '' },
      counter: 0,
      from: props.from,
      loading: false,
    }
  }

  geoApi = new GeoNames()
  location = async () => {
    return new Promise((resolve, reject) => {
      if ('geolocation' in navigator) {
        this.setState({
          fetchingLocation: true,
        })
        navigator.geolocation.getCurrentPosition(
          async function (position) {
            const lat = position.coords.latitude,
              lng = position.coords.longitude
            let country, timezone
            try {
            country = await this.geoApi.countryCode(lat, lng)
            timezone = await this.geoApi.timezone(lat, lng)
            } catch (e) {
              country = "Unknown"
              timezone = "Unknown"
            }
            this.setState({
              fetchingLocation: false,
              country,
            })
            resolve({ lat, lng, timezone, country })
          }.bind(this),
          (error) => {
            this.setState({
              fetchingLocation: false,
            })
            message.warning('Please Enable Location from Browser')
            console.error(error)
            resolve(error)
          },
          {
            timeout: 10 * 1000,
            maximumAge: 5 * 60 * 1000,
          }
        )
      } else {
        resolve({})
        message.error('Location is Not supported')
      }
    })
  }
  handleSubmit = async (user) => {
    try {
      user.location = await this.location()
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    try {
      this.setState({ loading: true })
      user.realm = 'pms'
      user = omit(user, ['remember'])
      user.loginIp = ''
      try {
        user.loginIp = await publicIp.v4()
      } catch (e) {}
      const response = await this.api.login(user)
      console.log(response, response.headers)
      await this.auth.setSession({
        token: response.headers.get('Session-Id'),
        loginIp: user.loginIp,
      })
      const result = await response.json()
      const member = await this.api.member(response.headers.get('Session-Id'))
      this.auth.setMember(member)
      if (result.expired === true)
        this.props.history.push({
          pathname: `/account`,
          search: '?expired=true',
          hash: 'password',
        })
      else {
        setTimeout(
          () =>
            this.props.history.push({
              pathname: this.state.from.pathname,
            }),
          1000
        )
      }
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({
        loading: false,
      })
    }
  }

  render() {
    return (
      <LoginFormComponent
        fetchingLocation={this.state.fetchingLocation}
        error={this.state.error}
        handleSubmit={this.handleSubmit}
        loading={this.state.loading}
      />
    )
  }
}

export default withRouter(LoginFormCont)
